import { ModelBase } from '../../core/model/model-base';
import { RoomType } from '../../dwelling-inspection/model/dwelling-inspection-room';
import { ObjectComponent } from './object-component';
export class Room extends ModelBase {
  constructor(model?: any) {
    super();
    if (model) {
      this.id = model.id;
      this.name = model.name;
      this.type = model.type;
      this.inspectionOrder = model.inspectionOrder;
      this.caption = model.caption;
      this.area = model.area;
      this.components = Array.isArray(model.components) ? model.components : [];
    }
  }
  components: ObjectComponent[];
  name: string;
  type: RoomType;
  inspectionOrder: number;
  caption: string;
  area: number;
}
